import { BiBookmarks, BiBrushAlt } from "react-icons/bi";
import { AiOutlineBank, AiOutlineFileImage } from 'react-icons/ai'
import { VscFeedback } from "react-icons/vsc";
import { FaQuestion } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { IoImagesOutline } from "react-icons/io5"


const icon = { size: "24px" };

export const routes = {
  sidebarRoutes: [

    // {
    //   name: "Stickers",
    //   path: "/sticker",
    //   icon: <PiStickerDuotone {...icon} />,
    //   items: [
    //     {
    //       name: "Sticker Store",
    //       path: "/sticker",
    //     },
    //     {
    //       name: "Sticker Tags",
    //       path: "/sticker-tags",
    //     },
    //   ]
    // },
    {
      name: "Feedback",
      path: "/feedback",
      key: "5b72d88a-a86f-4b15-b52c-a4b6dc8bc15c",
      icon: <VscFeedback {...icon} />,
      items: [
        {
          name: "Feedback",
          path: "/feedback",
          key: "5b72d88a-a86f-4b15-b52c-a4b6dc8bc15c",
        },
        {
          name: "Category List",
          path: "/feedback-category",
          key: "e19d52d5-d5f8-4eea-89a5-e200da5a7270",
        },
        // {
        //   name: "Sub Category List",
        //   path: "/feedback-sub-category",
        // },
        {
          name: "Rating",
          path: "/rating",
          key: "79fec086-9f14-4179-ad74-98fd729d3902",
        },
      ]
    },
    {
      name: "Themes",
      path: "/themes",
      key: "f10c02e9-3455-41dc-93ab-659d450d40c3",
      icon: <BiBrushAlt {...icon} />,
      items: [
        {
          name: "Themes",
          path: "/themes",
          key: "f10c02e9-3455-41dc-93ab-659d450d40c3",
        },
        {
          name: "Wallpaper",
          path: "/wallpaper",
          key: "c031e86f-68f7-4cc0-b585-5661d488b3e5",
        },
        {
          name: "Bubble",
          path: "/bubbles",
          key: "e3685cbe-6075-4d89-8255-9d1d716524a4",
        },
        {
          name: "Font",
          path: "/font",
          key: "9e133515-8e46-41ec-bdc3-d3f305f26a25",
        },
      ]
    },
    {
      name: "Blogs",
      icon: <BiBookmarks {...icon} />,
      key: "7ed7c66f-fb77-45fb-95a1-d0f01cd3cbc2",
      items: [
        {
          name: "Posts",
          path: "/addBlogs",
          key: "af863fcb-5795-4886-8ae5-aed8ae65e8aa",
        },
        {
          name: "Blog List",
          path: "/blogs",
          key: "7ed7c66f-fb77-45fb-95a1-d0f01cd3cbc2",
        },
        {
          name: "Categories",
          path: "/categories",
          key: "f1ab087c-52b3-4796-9367-dd0a1e80d22b",
        },
        {
          name: "Comments",
          path: "/comment",
          key: "695cd8c3-54d1-49ca-abeb-30e0a643bf09",
        },
      ]
    },
    {
      name: "Subscription",
      path: "/subscription",
      key: "d67fdc6a-5ac9-4e6b-b916-17dd60bfa0f4",
      icon: <AiOutlineFileImage {...icon} />
    },
    {
      name: "FAQ",
      path: "/faq",
      key: "67d023a2-6040-4e5f-8974-b7352ac2f818",
      icon: <FaQuestion  {...icon} />
    },
    {
      name: "Users",
      path: "/users",
      key: "01716d55-1ece-43b1-ab2b-49644e0eaa21",
      icon: <FaUser  {...icon} />
    },
    {
      name: "Assets Manager",
      path: "/asset",
      key: "ae5fd887-bfb5-4348-94b9-719da3aa3543",
      icon: <IoImagesOutline  {...icon} />
    },
    {
      name: "Binary Encoding",
      path: "/binaryEncoding",
      key: "de090938-164c-41af-9c0c-9d5bc9c0adf7",
      icon: <IoImagesOutline  {...icon} />
    },
    // {
    //   name: "Bank Details",
    //   path: "/bankDetails",
    //   key: "de090938-164c-41af-9c0c-9d5bc9c0adf7",
    //   icon: <AiOutlineBank  {...icon} />
    // },
    // {
    //   name: "Bank Regex",
    //   path: "/bankRegex",
    //   key: "de090938-164c-41af-9c0c-9d5bc9c0adf7",
    //   icon: <AiOutlineBank  {...icon} />
    // },
    {
      name: "Regex",
      icon: <BiBookmarks {...icon} />,
      key: "1bd92098-2da5-43bd-be07-5d1c2fcb95fa",
      items: [
        {
          name: "Bank Regex",
          path: "/bankRegex",
          key: "1bd92098-2da5-43bd-be07-5d1c2fcb95fa",
        },
        {
          name: "SMS Regex",
          path: "/smsRegex",
          key: "cff1164a-c6a7-482f-9d3e-b1ec520dc89f",
        },
        {
          name: "API Response",
          path: "/apiResponse",
          key: "999a5f3d-fa75-4534-b520-da305471b552",
        },
      ]
    },
    // {
    //   name: "Music",
    //   path: "/music",
    //   icon: <HiOutlineMusicalNote {...icon} />
    // },
  ],
};

export default routes;
